import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
:host {
  display: block;
  height: 100%;
}

.account-settings-page {
  min-height: 100%;
  background: var(--ro-canvas, #fafbf8);
}

.account-settings-header {
  position: sticky;
  inset-block-start: 0;
  z-index: 30;
  border: 0;
  background: #fff;
  box-shadow: inset 0 -1.111px 0 #e3e7de !important;
}

.profile-hero {
  position: relative;
  border-color: #dcd6c5;
  background-image: linear-gradient(112deg, rgba(108, 127, 54, 0.045), transparent 44%), linear-gradient(292deg, rgba(208, 130, 22, 0.045), transparent 38%);
  box-shadow: 0 1px 2px rgba(34, 24, 21, 0.035), 0 16px 38px rgba(65, 58, 35, 0.045);
}

.profile-hero::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: 280px;
  height: 100%;
  opacity: 0.45;
  pointer-events: none;
  background: radial-gradient(circle at 72% 18%, rgba(170, 85, 34, 0.11), transparent 34%), radial-gradient(circle at 28% 84%, rgba(108, 127, 54, 0.11), transparent 36%);
}

@media (max-width: 639px) {
  .profile-hero::after {
    width: 150px;
    opacity: 0.3;
  }
}
@media (min-width: 1024px) {
  .account-settings-header,
  .account-settings-header__inner {
    height: 124.444px;
    min-height: 124.444px;
    max-height: 124.444px;
  }
  .account-settings-header__inner {
    padding-block: 0;
  }
}
@media (min-width: 1800px) {
  .account-settings-header,
  .account-settings-header__inner {
    height: 112px;
    min-height: 112px;
    max-height: 112px;
  }
  .account-settings-header {
    box-shadow: inset 0 -1px 0 #e3e7de !important;
  }
}`],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public loading: boolean = true;
    public saving: boolean = false;
    public changingPassword: boolean = false;
    public showCurrentPassword: boolean = false;
    public showNewPassword: boolean = false;
    public originalProfile: any = { name: '', mobile: '' };

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call('get');
        if (code === 200) {
            this.user = data;
            this.originalProfile = {
                name: data.name || '',
                mobile: data.mobile || ''
            };
        } else {
            await this.service.modal.error('계정 정보를 불러오지 못했습니다.');
        }

        this.loading = false;
        await this.service.render();
    }

    public isAdmin() {
        return this.user?.role === 'admin'
            || this.service.auth.check.role('admin');
    }

    public roleLabel() {
        return this.isAdmin() ? '관리자' : '검수자';
    }

    public initial() {
        return this.user?.name?.charAt(0) || '사';
    }

    public profileCompletion() {
        if (!this.user) return 0;
        const fields = [this.user.email, this.user.name, this.user.mobile];
        return Math.round(fields.filter((value: any) => !!value).length / fields.length * 100);
    }

    public isProfileChanged() {
        if (!this.user) return false;
        return (this.user.name || '') !== this.originalProfile.name
            || (this.user.mobile || '') !== this.originalProfile.mobile;
    }

    public async updateProfile() {
        if (!this.user?.name?.trim()) {
            await this.service.modal.error('이름을 입력해주세요.');
            return;
        }
        if (this.saving || !this.isProfileChanged()) return;

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call('update_profile', {
            name: this.user.name.trim(),
            mobile: (this.user.mobile || '').trim()
        });

        this.saving = false;
        if (code === 200) {
            this.user.name = this.user.name.trim();
            this.user.mobile = (this.user.mobile || '').trim();
            this.originalProfile = {
                name: this.user.name,
                mobile: this.user.mobile
            };
            await this.service.modal.success('프로필이 업데이트되었습니다.');
        } else {
            await this.service.modal.error(data?.message || data || '업데이트에 실패했습니다.');
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (!current_password) {
            await this.service.modal.error('현재 비밀번호를 입력해주세요.');
            return;
        }
        if (!new_password || new_password.length < 8) {
            await this.service.modal.error('새 비밀번호는 8자 이상이어야 합니다.');
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error('새 비밀번호가 일치하지 않습니다.');
            return;
        }
        if (this.changingPassword) return;

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call('change_password', {
            current_password,
            new_password
        });

        this.changingPassword = false;
        if (code === 200) {
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
            this.showCurrentPassword = false;
            this.showNewPassword = false;
            await this.service.modal.success('비밀번호가 안전하게 변경되었습니다.');
        } else {
            await this.service.modal.error(data?.message || data || '비밀번호 변경에 실패했습니다.');
        }
        await this.service.render();
    }
}

export default PageMypageComponent;